
<div class="_dialog-title">
	<div class="flex-grow-1 text-xl">{{'pay_by_items_title' | translate}}</div>
	<button mat-icon-button (click)="cancel()" class="dialog-close-button">
		<mat-icon aria-label="Close Dialog">close</mat-icon>
	</button>
</div>

<div class="_dialog-content border-top">
	@if (totalOrderDiscount) {
		<div class="px-2 pt-3">
			<div class="alert alert-info mb-0">
				{{ 'pay_by_items_discount' | translate: {val: (totalOrderDiscount | lcurrency)} }}
			</div>
		</div>
	}


	<mat-selection-list #list class="mat-selection-list-reverse" style="margin-bottom: 150px;">
		@for ( offer of offers ; track offer) {
			<mat-list-option
				style="height: auto !important; min-height: 48px;"
				[selected]="offer.selected"
				[class.list-option-selected]="offer.selected" [value]="offer"
				(click)="onOfferSelected(list, $event)">

				<div style="display:flex; align-items:center" [class.list-option-selected]="offer.selected">
						<span class="flex-grow-1 text-ellipsis" style="font-weight: 500">
							{{ offer.name }}
						</span>
					@if (offer.originalPrice) {
						<span class="text-info" style="text-decoration:line-through; font-size:0.8em; margin-inline-end: 15px;">
						{{ offer.originalPrice | lcurrency }}
					</span>
					}
					<span class="text-accent" style="min-width: 81px; text-align: right;">{{ offer.price | lcurrency }}</span>
				</div>

				@if (offer.summary) {
					<div  class="_offer-summary text-info">
						@for ( member of offer.summary ; track member) {
							<div style="white-space: nowrap;">
								<span class="mr-1">{{member.name}}:</span>
								<b>{{member.price | lcurrency}}</b>
							</div>
						}
					</div>
				}
			</mat-list-option>
		}
	</mat-selection-list>
</div>

<div class="_dialog-actions">

	<div class="_balance-info mb-2">
		<div class="mr-3">{{'PO.REMAINED_PAY' | translate}}:</div>
		<div>{{this.data.balanceDue | lcurrency:'1.2-2'}}</div>
	</div>

	<button mat-raised-button color="accent" class="lg main-continue-btn" type="button" (click)="apply()" [disabled]="!total">
		<div class="_inner">
			<span>{{'PAY' | translate}}</span>
			<span *ngIf="total">{{total | lcurrency}}</span>
			<div class="_cont rotate-rtl"><mat-icon svgIcon="arrow_next"></mat-icon></div>
		</div>
	</button>

	<div class="text-accent text-center font-bold mt-1 animated faster slideInUp" *ngIf="this.total > this.data.balanceDue">
		{{'surcharge_will_be_added_to_tip' | translate}}
	</div>
</div>

